import { cn } from "@/lib/cn"

interface ArchieRobotProps {
  size?: "sm" | "md"
  className?: string
  speaking?: boolean
}

/** Simple circle-robot avatar for the Archie launcher. */
export function ArchieRobot({
  size = "md",
  className,
  speaking = false,
}: ArchieRobotProps): JSX.Element {
  const dim = size === "sm" ? "h-10 w-10" : "h-14 w-14"

  return (
    <div
      className={cn(
        "relative flex items-center justify-center rounded-full bg-[#1f3d2b] text-[#e7f2ea] shadow-md",
        dim,
        speaking && "ring-2 ring-[#c4a35a]/70",
        className
      )}
      aria-hidden="true"
    >
      <svg viewBox="0 0 64 64" className="h-[70%] w-[70%]" fill="none">
        <circle cx="32" cy="34" r="18" fill="#2f5d40" />
        <rect x="22" y="12" width="20" height="8" rx="4" fill="#c4a35a" />
        <circle cx="32" cy="12" r="3" fill="#e7f2ea" />
        <circle cx="25" cy="33" r="3.5" fill="#e7f2ea" />
        <circle cx="39" cy="33" r="3.5" fill="#e7f2ea" />
        <circle cx="25" cy="33" r="1.5" fill="#1f3d2b" />
        <circle cx="39" cy="33" r="1.5" fill="#1f3d2b" />
        <path
          d="M24 42c2.5 3 13.5 3 16 0"
          stroke="#e7f2ea"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <rect x="14" y="30" width="5" height="10" rx="2" fill="#c4a35a" />
        <rect x="45" y="30" width="5" height="10" rx="2" fill="#c4a35a" />
      </svg>
    </div>
  )
}
